import * as React from 'react';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary, ViewMedium, Viewport, ViewSmall } from 'bernie-view';
import { MesoTrigger } from 'components/meso/meso-trigger';

interface MesoNativeResultListingProps {
  uci: string;
  className: string;
  errorBoundaryLabel?: string;
}

interface MesoNativeResultListingState {
  adServed: boolean;
  adServedMobile: boolean;
}

export class MesoNativeResultListing extends React.Component<MesoNativeResultListingProps, MesoNativeResultListingState> {
  private adRef;
  private adRefMobile;

  public static defaultProps = {
    errorBoundaryLabel: 'hotel.meso'
  };

  constructor(props) {
    super(props);
    this.state = {
      adServed: false,
      adServedMobile: false
    };
    this.adRef = React.createRef();
    this.adRefMobile = React.createRef();
  }

  public componentDidMount() {
    // Attach the event listener for the ad request.
    const node = this.adRef.current;

    if (node) {
      node.addEventListener('mesoAd', e => {
        if (e && e.detail) {
          if (e.detail.code === 'AD-LOAD-PASS') {
            this.setState({
              adServed: true
            });
          }
          if (e.detail.code === 'AD-LOAD-FAIL') {
            this.setState({
              adServed: false
            });
          }
        }
      });
    }

    // Attach the event listener for the ad request.
    const nodeMobile = this.adRefMobile.current;

    if (nodeMobile) {
      nodeMobile.addEventListener('mesoAd', e => {
        if (e && e.detail) {
          if (e.detail.code === 'AD-LOAD-PASS') {
            this.setState({
              adServedMobile: true
            });
          }
          if (e.detail.code === 'AD-LOAD-FAIL') {
            this.setState({
              adServedMobile: false
            });
          }
        }
      });
    }
  }

  public render() {
    return (
      <ErrorBoundary label={this.props.errorBoundaryLabel}>
        <Viewport>
          <ViewSmall>
            <AbacusExperiment name="PWA_Mobile_MeSo_Native_Results_Listings">
              <AbacusControl />
              <AbacusVariant bucket={1}>
                <li data-stid="native-results-listing" className={this.state.adServedMobile ? this.props.className : ''}>
                  <meso-native-results-listing ref={this.adRefMobile} uci={this.props.uci + 'M'} />
                </li>
              </AbacusVariant>
            </AbacusExperiment>
          </ViewSmall>
          <ViewMedium>
            <li data-stid="native-results-listing" className={this.state.adServed ? this.props.className : ''}>
              <meso-native-results-listing ref={this.adRef} {...this.props} />
            </li>
          </ViewMedium>
        </Viewport>
        <MesoTrigger pageName="page.Hotels.Search" />
      </ErrorBoundary>
    );
  }
}
